export interface PermissionEntity {
    resource: string,
    read: boolean,
    modify: boolean,
    create: boolean,
    delete: boolean,
    attributes: string[],
    tempAttributes: string,
    tempResource?: string[],
    forceRefresh?: boolean // used to force refresh the permission table
}

export const EMPTY_PERMISSION_ENTITY: PermissionEntity = {
    resource: "",
    read: false,
    modify: false,
    create: false,
    delete: false,
    attributes: [],
    tempResource: [],
    tempAttributes: "",
    forceRefresh: false
}